export default __webpack_public_path__ + "a48ea20cf2c79e059b5cf4b8b12d7dcc.svg";